import { ChatTextIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ReportDescription = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ChatTextIcon {...rest} size={Sizes[size]} color={fill} />;
};

ReportDescription.displayName = 'ReportDescription';
